<script lang="ts" setup>
// @ts-nocheck - Property 'index' does not exist on type '{ $: ComponentInternalInstance; $data: {}; $props: Partial<{}> & Omit<Readonly<ExtractPropTypes<__VLS_TypePropsToRuntimeProps<PagebuilderAccordionProps>>> & VNodeProps & AllowedComponentProps & ComponentCustomProps, never>; ... 10 more ...; $watch<T extends string | ((...args: any) => any)>(source: T, cb: T extends ...'.
import type { BankProducts } from '~~/server/api/insurance/bank/insurance'
import type { TabLink } from '~/components/tabs/Tabs.vue'

export interface PagesBankInsuranceProductsTabsProps {
    data: BankProducts
}

const props = defineProps<PagesBankInsuranceProductsTabsProps>()
const bankProductsLinks = computed<TabLink[]>(() =>
    props.data.data.map((item) => {
        return {
            name: item.title,
            id: item.id,
        }
    })
)
</script>
<template>
  <!-- eslint-disable vue/no-v-html -->
  <section>
    <h2
      v-if="props.data.bank_products_title"
      class="gamma mb-6 mb-md-12"
    >
      {{ props.data.bank_products_title }}
    </h2>
    <Tabs
      :select-on-mobile="true"
      type="tertiary"
      direction="vertical"
      tabs-id="PagesBankInsuranceProductsTabs"
      :select-label="$t('Vyberte službu')"
      :links="bankProductsLinks"
    >
      <template
        v-for="(item, index) in props.data.data"
        :key="index"
        #[`tab-panel-${index}`]
      >
        <article class="rounded-4 bg-white box-shadow-1 p-4 p-lg-10">
          <Typo>
            <div v-html="item.description" />
          </Typo>
        </article>
      </template>
    </Tabs>
  </section>
</template>
